// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Sonner toast z-index fix to ensure toasts appear above all elements */
[data-sonner-toaster] {
  z-index: 99999999 !important;
}

[data-sonner-toast] {
  z-index: 99999999 !important;
}

/* Ensure toast container has highest z-index */
.sonner-toast-container {
  z-index: 99999999 !important;
}

/* Override any conflicting z-index values */
.toaster {
  z-index: 99999999 !important;
}
`, "",{"version":3,"sources":["webpack://./src/toast-fix.css"],"names":[],"mappings":"AAAA,wEAAwE;AACxE;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,+CAA+C;AAC/C;EACE,4BAA4B;AAC9B;;AAEA,4CAA4C;AAC5C;EACE,4BAA4B;AAC9B","sourcesContent":["/* Sonner toast z-index fix to ensure toasts appear above all elements */\n[data-sonner-toaster] {\n  z-index: 99999999 !important;\n}\n\n[data-sonner-toast] {\n  z-index: 99999999 !important;\n}\n\n/* Ensure toast container has highest z-index */\n.sonner-toast-container {\n  z-index: 99999999 !important;\n}\n\n/* Override any conflicting z-index values */\n.toaster {\n  z-index: 99999999 !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
